import { DashboardLayout } from "@/components/dashboard/dashboard-layout";
import ArchivedEmployeeList from "./ArchivedEmployeeList";

export default function ArchivedEmployeesPage() {
  return (
    <DashboardLayout activeTab="company-profile">
      <ArchivedEmployeeList />
    </DashboardLayout>
  );
}
